
import {defineComponent} from "vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {handleSavedSuccessfully} from "@/helpers/toast-helper";
import CatalogBuildStatus from "@/components/layouts/catalog/CatalogBuildStatus.vue";
import {DpReferencePriceSettingsRestDtoModel} from "@/models/api/pharma-cpc-mgmt/DpReferencePriceSettingsRestDtoModel";
import {BasePricesRestService} from "@/services/rest/cpc-mgmt/BasePricesRestService";
import InputRadio from "@/components/UI/InputRadio.vue";
import {ReferencePricePresentationEnum} from "@/api/enums/reference-price-presentation-enum";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import RangeSlider from "@/components/UI/RangeSlider.vue";
import InputNumber from "@/components/UI/InputNumber.vue";
import { Tooltip } from 'bootstrap';

export default defineComponent({
  name: "BasePrices",
  components: {
    InputNumber,
    RangeSlider,
    InputCheckboxBoolean,
    InputRadio,
    CatalogBuildStatus,
    AlertError2,
    BaseTitle,
  },
  data() {
    return {
      basePricesUI: UIStateDto.createWithDefaults(),
      priceSettings: DpReferencePriceSettingsRestDtoModel.createWithDefaults(),
    }
  },
  async mounted() {
    await this.reloadContent();

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      new Tooltip(el as Element);
    });
  },
  computed: {
    ReferencePricePresentationEnum() {
      return ReferencePricePresentationEnum
    }
  },
  methods: {
    async reloadContent() {
      this.basePricesUI
        .setNotReady()
        .clearError();

      try {
        this.priceSettings = await BasePricesRestService.getInstance().getReferencePriceSettings();
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.basePricesUI.setReady();
      }
    },
    async submitData() {
      console.log('submitData');
      this.basePricesUI
        .clearError()
        .setNotReady();

      try {
        await BasePricesRestService.getInstance().updateReferencePriceSettings(this.priceSettings);
        await this.handleSavedSuccessfully();
        await this.reloadContent();
      } catch (exceptions: any) {
        this.setExceptions(exceptions);
        window.scrollTo(0, 0);
      } finally {
        this.basePricesUI.setReady();
      }
    },
    selectPresentationCode(code: ReferencePricePresentationEnum): void {
      if (!this.priceSettings.is_opt_out_for_price_sharing) {
        this.priceSettings.presentation_code = code;
      }
    },
    optOutChanged(): void {
      if (this.priceSettings.is_opt_out_for_price_sharing) {
        this.priceSettings.presentation_code = ReferencePricePresentationEnum.SHOW_NOTIFICATION_NO_PRICE;
        this.priceSettings.global_correction_value = 0;
      }
    },
    handleSavedSuccessfully,
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
        .create()
        .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.basePricesUI as UIStateDto))
        .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.basePricesUI as UIStateDto))
        .catch(exceptions, true);
    }
  },
});
